import { Route } from '@angular/router';
import { SecureComponent } from './secure.component';
import { authGuard } from '../../_guards/auth.guard';

export const secureRoutes: Route[] = [
  {
    path: 'secure',
    component: SecureComponent,
    canActivate: [authGuard],
    children: [
      {
        path: 'generate-key',
        loadComponent: () =>
          import('./generate-key/generate-key.component').then(
            (m) => m.GenerateKeyComponent,
          ),
      },
      {
        path: 'email-change',
        loadComponent: () =>
          import('./email-change/email-change.component').then(
            (m) => m.EmailChangeComponent,
          ),
      }
    ],
  },

  // {
  //   path: '**',
  //   redirectTo: 'secure/generate-key',
  // },
];
